module.exports = __webpack_public_path__ + "media/images/global/icons/bride-wa-3c11c69d2eeaac724c9283fe0e9730e6.svg";